<script setup>
import { computed, onMounted, onUnmounted } from "vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  duration: {
    type: Number,
    default: 5000,
  },
  type: {
    type: String,
    default: "success",
    validator: (value) => ["success", "error"].includes(value),
  },
});

const emit = defineEmits(["close-toast"]);

let timer = null;

const iconPath = computed(() => {
  const paths = {
    success: "M2.667 9 5.667 12 13 4.667",
    error: "M4 4 12 12M12 4 4 12",
  };
  return paths[props.type] || paths.success;
});

onMounted(() => {
  timer = setTimeout(() => emit("close-toast"), props.duration);
});

onUnmounted(() => {
  clearTimeout(timer);
});
</script>

<template>
  <div class="toast-custom__row">
    <div class="toast-custom__fold">
      <div class="toast-custom__item" :class="[type]">
        <div class="toast-custom__content">
          <div class="toast-custom__icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <path
                :d="iconPath"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p class="toast-custom__title">{{ title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.toast-custom__content {
  display: flex;
  align-items: center;
  gap: 8px;
}
.toast-custom {
  &__row {
    display: grid;
    grid-template-rows: 1fr;
  }

  &__fold {
    min-height: 0;
  }

  .toast-custom__icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    color: #fff;
    background-color: var(--toast-icon-bg);
  }

  &__item {
    --toast-icon-bg: var(--forest-500);

    background: #fff;
    box-shadow: 0 8px 24px -10px rgba(29, 29, 29, 0.16);
    overflow: hidden;
    border-radius: 16px;
    padding: 16px;
    position: relative;
    display: inline-block;
    max-width: 100%;
    box-sizing: border-box;

    &.error {
      --toast-icon-bg: var(--red-600);
    }
  }

  &__title {
    margin: 0;
    font-family: var(--font-manrope);
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    color: var(--gray-950);
  }
}
</style>
